<script lang="ts">
  import { Cobros, Pacientes, type CobroPendiente } from '../lib/api';

  let {
    onSelect,
  }: {
    onSelect: (pacienteId: string, pacienteNombre?: string) => void;
  } = $props();

  let items = $state<CobroPendiente[]>([]);
  let nombres = $state<Record<string, string>>({});
  let loading = $state(false);
  let error = $state<string | null>(null);

  async function cargar() {
    loading = true;
    error = null;
    try {
      items = await Cobros.pendientes();
      const map: Record<string, string> = { ...nombres };
      for (const it of items) {
        if (!it.pacienteId || map[it.pacienteId]) continue;
        try {
          const p = await Pacientes.uno(it.pacienteId);
          map[it.pacienteId] = `${p.nombres} ${p.apellidos}`.trim();
        } catch {
          map[it.pacienteId] = it.pacienteId.slice(0, 8) + '…';
        }
      }
      nombres = map;
    } catch (e: any) {
      error = e?.message ?? String(e);
    } finally {
      loading = false;
    }
  }

  async function cancelar(it: CobroPendiente, e: MouseEvent) {
    e.stopPropagation();
    if (!it.id || !confirm('¿Cancelar este cobro pendiente?')) return;
    try {
      await Cobros.cancelarPendiente(it.id);
      await cargar();
    } catch (err: any) {
      error = err?.message ?? String(err);
    }
  }

  function seleccionar(it: CobroPendiente) {
    onSelect(it.pacienteId, nombres[it.pacienteId]);
  }

  $effect(() => { cargar(); });
</script>

<aside class="bandeja">
  <div class="head">
    <h4>Bandeja pendientes</h4>
    <button type="button" onclick={cargar} disabled={loading} title="Recargar">{loading ? '…' : '↻'}</button>
  </div>
  {#if error}<p class="err">{error}</p>{/if}
  <ul>
    {#each items as it (it.id)}
      <li>
        <button type="button" class="item" onclick={() => seleccionar(it)}>
          <span class="nombre">{nombres[it.pacienteId] ?? 'Paciente'}</span>
          <span class="monto">Q{Number(it.montoTotal).toFixed(2)}</span>
          {#if it.notas}<span class="nota">{it.notas}</span>{/if}
          {#if it.vencimiento}
            <span class="vence">Vence {it.vencimiento.slice(0, 10)}</span>
          {/if}
        </button>
        <button type="button" class="cancel" onclick={(e) => cancelar(it, e)} title="Cancelar">×</button>
      </li>
    {:else}
      <li class="empty">{loading ? 'Cargando…' : 'Sin cobros postergados.'}</li>
    {/each}
  </ul>
</aside>

<style>
  .bandeja {
    border: 1px solid #d6e7ea; border-radius: 10px; background: #f8fcfd;
    padding: .75rem; min-width: 14rem; max-width: 18rem;
  }
  .head { display: flex; justify-content: space-between; align-items: center; margin-bottom: .5rem; }
  .head h4 { margin: 0; font-size: .92rem; }
  .head button { background: none; border: 0; cursor: pointer; font-size: 1rem; color: #16a34a; }
  ul { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: .35rem; }
  li { display: flex; gap: .25rem; align-items: stretch; }
  .item {
    flex: 1; text-align: left; padding: .5rem .6rem;
    border: 1px solid #cde; border-radius: 8px; background: #fff;
    cursor: pointer; font: inherit; display: flex; flex-direction: column; gap: .1rem;
  }
  .item:hover { border-color: #16a34a; background: #ecfdf5; }
  .nombre { font-weight: 600; font-size: .85rem; }
  .monto { color: #16a34a; font-weight: 700; font-size: .88rem; }
  .nota, .vence { font-size: .75rem; color: #5B7480; }
  .cancel {
    background: #fff; border: 1px solid #ddd; border-radius: 8px;
    width: 2rem; cursor: pointer; color: #900; font-size: 1.1rem;
  }
  .empty { color: #888; font-size: .85rem; font-style: italic; padding: .5rem 0; }
  .err { color: #900; font-size: .8rem; margin: 0 0 .4rem; }
</style>
